import { render } from "./thinktank.vue?vue&type=template&id=f320350c&scoped=true"
import script from "./thinktank.vue?vue&type=script&lang=js"
export * from "./thinktank.vue?vue&type=script&lang=js"

import "./thinktank.vue?vue&type=style&index=0&id=f320350c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f320350c"]])

export default __exports__